// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_jb-6";
export var emphasizeQuantity = "_jb-3";
export var flatBottomCorners = "_jb-5";
export var productImage = "_jb-0";
export var quantityContainer = "_jb-2";
export var tooltip = "_jb-1";
export var wrapAndEllipsesOverflow = "_jb-4";